import * as React from "react"

const CloseQAndASvg = (props) => (
	<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_d_15240_25677)">
			<circle cx="30" cy="26" r="26" fill="#243661" />
		</g>
		<path
			d="M36.4395 21.2422C36.553 21.1327 36.6435 21.0017 36.7058 20.8569C36.7681 20.712 36.801 20.5562 36.8024 20.3985C36.8039 20.2409 36.7739 20.0845 36.7142 19.9385C36.6546 19.7925 36.5665 19.6599 36.4551 19.5484C36.3436 19.4368 36.2111 19.3486 36.0652 19.2888C35.9192 19.229 35.7629 19.1989 35.6052 19.2002C35.4475 19.2015 35.2917 19.2342 35.1468 19.2963C35.0019 19.3585 34.8708 19.4489 34.7612 19.5623L30.0017 24.3202L25.2438 19.5623C25.1351 19.4456 25.004 19.352 24.8583 19.2871C24.7126 19.2222 24.5554 19.1873 24.3959 19.1845C24.2365 19.1817 24.0781 19.211 23.9303 19.2708C23.7824 19.3305 23.6481 19.4194 23.5353 19.5321C23.4225 19.6449 23.3337 19.7792 23.2739 19.9271C23.2142 20.0749 23.1849 20.2333 23.1877 20.3928C23.1905 20.5522 23.2254 20.7095 23.2903 20.8551C23.3552 21.0008 23.4488 21.1319 23.5655 21.2406L28.3202 26.0001L23.5623 30.758C23.3525 30.9831 23.2383 31.2809 23.2438 31.5885C23.2492 31.8962 23.3738 32.1897 23.5914 32.4073C23.809 32.6248 24.1025 32.7495 24.4101 32.7549C24.7178 32.7603 25.0155 32.6461 25.2406 32.4364L30.0017 27.6784L34.7596 32.4379C34.9847 32.6477 35.2825 32.7619 35.5901 32.7565C35.8978 32.751 36.1913 32.6264 36.4089 32.4088C36.6264 32.1913 36.7511 31.8978 36.7565 31.5901C36.7619 31.2825 36.6477 30.9847 36.438 30.7596L31.6832 26.0001L36.4395 21.2422Z"
			fill="white"
		/>
		<defs>
			<filter
				id="filter0_d_15240_25677"
				x="0"
				y="0"
				width="60"
				height="60"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="2" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15240_25677" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15240_25677" result="shape" />
			</filter>
		</defs>
	</svg>
)

export default CloseQAndASvg
